module.exports = __webpack_public_path__ + "img/sdg_es_(10).d1452954.png";